(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2724);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);



var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        width: "26",
        height: "11",
        viewBox: "0 0 26 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24 7C25.1046 7 26 7.89543 26 9V9C26 10.1046 25.1046 11 24 11L2 11C0.89543 11 -1.35705e-07 10.1046 -8.74228e-08 9V9C-3.91405e-08 7.89543 0.895431 7 2 7L24 7Z",
                fill: "#5E6B7E"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M25.0711 7.24253C25.8522 8.02357 25.8522 9.2899 25.0711 10.071V10.071C24.2901 10.852 23.0238 10.852 22.2427 10.071L16.4143 4.24253C15.6332 3.46148 15.6332 2.19515 16.4143 1.4141V1.4141C17.1953 0.63305 18.4617 0.63305 19.2427 1.4141L25.0711 7.24253Z",
                fill: "#5E6B7E"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 2724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 8 modules
var wagmi = __webpack_require__(46831);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/util/getWindowSize.ts
var getWindowSize = __webpack_require__(33904);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(49444);
// EXTERNAL MODULE: ./src/hooks/useSessionChainId.ts
var useSessionChainId = __webpack_require__(67994);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(199);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx
var Page = __webpack_require__(75915);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/views/HomeView/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    background: ",
        ";\n    display: flex;\n    flex-direction:column;\n    justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: auto;\n    max-width: 1320px;\n    position: relative;\n    @media screen and (max-width: 768px){\n        margin: 0;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-wrap: wrap;\n    min-height: 680px;\n    align-items: center;\n    justify-content: space-between;\n    @media screen and (max-width: 600px){\n      min-height: 400px;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    max-width: 60%;\n    margin-left: 110px;\n    grid-gap: 20px;\n    width: 60%;\n    gap: 20px;\n    top: 5%;\n    flex-direction: column;\n    @media screen and (max-width: 768px){\n      max-width: 80%;\n      width: 100%;\n      margin-left: 0;\n      gap: 10px;\n      margin-top:-200px;\n      top: auto;\n    }\n    @media screen and (max-width: 600px){\n      max-width: 90%;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    align-items: left;\n    margin-bottom: 20px;\n    @media screen and (max-width: 768px){\n      margin-bottom: 10px;\n    }\n    ",
        "{\n      color: ",
        ";\n        &:first-child{\n          font-size: 18px;\n          letter-spacing: 0.05em;\n          text-transform: uppercase;\n          @media screen and (max-width: 768px){\n            font-size: 14px;\n          }\n        }\n        &:nth-child(2){\n          font-size: 80px;\n          font-weight: 900;\n          line-height: normal;\n          @media screen and (max-width: 768px){\n            font-size: 24px;\n            line-height: 1.5;\n          }\n        };\n        &:nth-child(3){\n          font-size: 24px;\n          @media screen and (max-width: 768px){\n            font-size: 14px;\n          }\n        }\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    justify-content: flex-end;\n    img{\n        height: auto;\n        max-width: 55%;\n        margin-top: 0;\n        margin-right: -10px;\n        @media screen and (max-width: 600px){\n            max-width: 130%;\n            width: 130%;\n            margin-top: 0;\n            margin-right: -245px;\n        }\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 48px;\n    padding: 0 20px;\n    text-transform: uppercase;\n    padding: 2px 24px;\n    background: #0081e2;\n    color: ",
        ";\n    border: 2px solid ",
        ";\n    cursor: pointer;\n    font-size: 14px;\n    @media screen and (max-width: 768px){\n      font-size: 10px;\n      height: 32px;\n      padding: 0 5px;\n}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 500;\n  margin-left: 32px;\n  text-transform: uppercase;\n  color: ",
        ";\n  @media screen and (max-width: 768px){\n    margin-left: 16px;\n    font-weight: 700;\n    font-size: 10px;\n  }\n  &:hover{\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  font-size: 60px;\n  font-weight: 900;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: ",
        ";\n  @media screen and (max-width: 768px){\n    font-size: 24px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  max-width: 1320px;\n  margin-top: 64px;\n  flex-wrap: wrap;\n  gap: 4rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  @media screen and (max-width: 1000px){\n    justify-content: center;\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media screen and (max-width: 600px){\n    grid-template-columns: repeat(1, 1fr);\n    place-items: center;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (max-width: 1024px){\n        width: 100%;\n        display: flex;\n        justify-content: center;\n      }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 137px;\n    max-width: 1320px;\n    @media screen and (max-width: 1024px){\n        margin-bottom: 150px;\n        }\n    h4{\n        color: #FFF;\n        font-size: 60px;\n        font-style: normal;\n        font-weight: 900;\n        line-height: 88px;\n        @media screen and (max-width: 1024px){\n            text-align: center;\n            font-size: 24px;\n        }\n    }\n    h6{\n        color: #FFF;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 36px;\n        max-width: 630px;\n        width: 100%;\n        display: flex;\n        @media screen and (max-width: 1024px){\n            color: #FFF;\n            text-align: center;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            max-width: 300px;\n            margin: auto;\n        }\n    }\n    .mySwiper{\n        margin-top: 52px;\n        display: none;\n        max-width: 1320px;\n        padding: 0 20px;\n        margin: auto;\n        @media screen and (max-width: 1024px){\n            display: block;\n            position: absolute;\n            left: -20px;\n            max-width: 100%;\n            margin-top: 24px;\n        }\n        .swiper-pagination{\n            display: none !important;\n        }\n    }\n    .wrapper-img{\n        justify-content: center;\n        display: flex;\n        gap: 84px;\n        flex-flow: wrap;\n        margin-top: 52px;\n        @media screen and (max-width: 1024px){\n            display: none;\n        }\n    }\n    img{\n        width: 150px;\n        height: 150px;\n        @media screen and (max-width: 1024px){\n            border-radius: 12px;\n            width: 80px;\n            height: 80px;\n        }\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    @media screen and (max-width: 768px){\n        width: 150px;\n        margin-bottom: 0;\n        bottom: 200px;\n        position: relative;\n        height: 0;\n    }\n  img{\n    width: 24px;\n    height: 48px;\n  }\n  p{\n    @media screen and (max-width: 768px){\n        font-size: 13px;\n    }\n    color: #FFF;\n    font-family: 'Inter';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: normal;\n    letter-spacing: 0.6px;\n    margin-top: 24px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var CustomPage = (0,styled_components_browser_esm/* default */.ZP)(Page/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.main;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6b823d2-1"
})(_templateObject1());
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-2"
})(_templateObject2());
var CsLeftHero = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-3"
})(_templateObject3());
var CsContentLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-4"
})(_templateObject4(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsRightImg = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-5"
})(_templateObject5());
var CustomButtonConnectWallet = (0,styled_components_browser_esm/* default */.ZP)(ConnectWalletButton/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.disable;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsCrollDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6b823d2-8"
})(_templateObject8());
var CsTextCroll = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsHeaderSection = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-10"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var WrapListItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6b823d2-11"
})(_templateObject11());
var CsWrapItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6b823d2-12"
})(_templateObject12());
var CsOurPartners = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6b823d2-13"
})(_templateObject13());
var CsScroll = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6b823d2-14"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/views/HomeView/components/Section1.tsx










var Section1 = function() {
    var windownSize = (0,getWindowSize/* default */.Z)();
    var isConnected = (0,dist/* useAccount */.mA)().isConnected;
    var logout = (0,useAuth/* default */.Z)().logout;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useSessionChainId/* useSessionChainId */.o)(), 2), setSessionChainId = ref[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsLeftHero, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsContentLeft, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "INTRODUCING CLOUDBASE"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        children: [
                                            "Pioneer DEX on BASE ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "All-in-One Platform"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "An all-inclusive Defi platform for BASE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "flex-start",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsLink, {
                                        target: "_blank",
                                        href: "https://doc.cloudbase.finance",
                                        children: "WHITEPAPER"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsLink, {
                                        href: "/swap",
                                        children: "TRADE NOW"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsRightImg, {
                        children: windownSize > 600 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/home/hero_images.png?version=1.1",
                            alt: ""
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/home/hero-mobile.png?version=1.2",
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsScroll, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/base_img/scroll-icon.png?version=1.1",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "SCROLL TO EXPLORE"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Section1 = (Section1);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(56685);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode.css
var free_mode = __webpack_require__(48385);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(33135);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(99304);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(84453);
;// CONCATENATED MODULE: ./src/views/HomeView/components/Item.tsx

function Item_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 400px;\n    height: 100%;\n    min-height: 380px;\n    border-radius: 10px;\n    margin-bottom: 5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: url(",
        ") center top / 100% 100% no-repeat;\n    padding: 3rem 2rem;\n    position: relative;\n    @media screen and (max-width: 1024px){\n      padding: 2rem 2rem;\n    }\n"
    ]);
    Item_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Item_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 28px;\n    margin-top: 80px;\n    line-height: 38px;\n    font-weight: 900;\n    letter-spacing: -0.02em;\n    color: ",
        ";\n    @media screen and (max-width: 1024px){\n        font-size: 24px;\n    }\n"
    ]);
    Item_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Item_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 14px;\n  margin-top: 16px;\n  @media screen and (max-width: 1024px){\n        font-size: 13px;\n    }\n"
    ]);
    Item_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Item_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -120px;\n  left: 50%;\n  width: 240px;\n  height: 240px;\n  transform: translatex(-50%);\n"
    ]);
    Item_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Item_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    Item_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var Item = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapItem, {
        background: item === null || item === void 0 ? void 0 : item.img,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsSubImg, {
                        src: item === null || item === void 0 ? void 0 : item.imgSub,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTitle, {
                        children: [
                            " ",
                            item === null || item === void 0 ? void 0 : item.title,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsSubTitle, {
                        children: [
                            " ",
                            item === null || item === void 0 ? void 0 : item.subTitle,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: item === null || item === void 0 ? void 0 : item.color,
                        children: "Learn more"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
                ]
            })
        ]
    });
};
var WrapItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dcd6cc4b-0"
})(Item_templateObject(), function(param) {
    var background = param.background;
    return background;
});
var CsTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-dcd6cc4b-1"
})(Item_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.title;
});
var CsSubTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-dcd6cc4b-2"
})(Item_templateObject2());
var CsSubImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-dcd6cc4b-3"
})(Item_templateObject3());
var Item_CsLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-dcd6cc4b-4"
})(Item_templateObject4());
/* harmony default export */ var components_Item = (Item);

;// CONCATENATED MODULE: ./src/views/HomeView/components/Section2.tsx




// Import Swiper styles






var data = [
    {
        id: 1,
        img: "/images/base_img/oneBig.png",
        imgSub: "/images/base_img/one.png",
        title: "Trade Anything",
        subTitle: "Trade any token on BASE in seconds, just by connecting your wallet.",
        link: "",
        color: "#6F5BEB"
    },
    {
        id: 2,
        img: "/images/base_img/twoBig.png",
        imgSub: "/images/base_img/two.png",
        title: "Earn passive income",
        subTitle: "CloudBase makes it easy to make your crypto work for you. Let your Clouds work for you.",
        link: "",
        color: "#FFC600"
    },
    {
        id: 3,
        img: "/images/base_img/threeBig.png",
        imgSub: "/images/base_img/three.png",
        title: "AMM NFT Marketplace",
        subTitle: "AMM NFT Marketplace allows users to trade NFTs in Liquidity Pool thereby fostering more Defi to NFTs and enabling easy trading of assets.",
        link: "",
        color: "#89EB5B"
    }
];
var Section2 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurPartners, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsHeaderSection, {
                children: "Why CloudBase"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapListItem, {
                children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Item, {
                            item: item
                        })
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var components_Section2 = (Section2);
var OurPartners = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsOurPartners, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Our Partners"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                children: "As a partner, it is important to have a positive experience using the website or app"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                slidesPerView: 4,
                spaceBetween: 6,
                freeMode: true,
                pagination: {
                    clickable: true
                },
                modules: [
                    modules/* FreeMode */.Rv,
                    modules/* Pagination */.tl
                ],
                className: "mySwiper",
                children: (0,_to_consumable_array/* default */.Z)(Array(11)).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "images/base_img/partners".concat(index + 1, ".png"),
                            alt: ""
                        })
                    }, "".concat(index.toString()));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "wrapper-img",
                children: (0,_to_consumable_array/* default */.Z)(Array(11)).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "images/base_img/partners".concat(index + 1, ".png"),
                        alt: ""
                    }, "".concat(index.toString()));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/HomeView/components/Section3.tsx


function Section3_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n     @media screen and (max-width: 768px){\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n"
    ]);
    Section3_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Section3_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    @media screen and (max-width: 768px){\n        max-width: 75%;\n    }\n"
    ]);
    Section3_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Section3_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* width: 50%; */\n  @media screen and (max-width: 768px){\n        max-width: 25%;\n    }\n  img{\n    width: 100%;\n    max-width: 718px;\n    max-height: 718px;\n  }\n"
    ]);
    Section3_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Section3_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-around;\n  margin: 50px 0;\n  max-width: 1320px;\n  padding-left: 88px;\n  @media screen and (max-width: 768px){\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    Section3_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Section3_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    align-items: left;\n    margin-bottom: 20px;\n    @media screen and (max-width: 768px){\n      margin-bottom: 10px;\n    }\n    ",
        "{\n      color: ",
        ";\n        &:first-child{\n          font-size: 48px;\n          font-weight: 900;\n          @media screen and (max-width: 768px){\n            font-size: 24px;\n          }\n        }\n        &:nth-child(2){\n          font-size: 18px;\n          letter-spacing: 0.05em;\n          max-width: 465px;\n          color: ",
        ";\n          @media screen and (max-width: 768px){\n            font-size: 13px;\n            max-width: 100%;\n          }\n        };\n    }\n"
    ]);
    Section3_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var Section3 = function() {
    var windownSize = (0,getWindowSize/* default */.Z)();
    var isConnected = (0,dist/* useAccount */.mA)().isConnected;
    var logout = (0,useAuth/* default */.Z)().logout;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useSessionChainId/* useSessionChainId */.o)(), 2), setSessionChainId = ref[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsLeft, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section3_CsContentLeft, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: "#62FFD9"
                                            },
                                            children: "Explore"
                                        }),
                                        " opportunities from BASE ecosystem"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: "Automated and fully-audited trading mechanism in an understandable interface."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapperLink, {
                            justifyContent: "flex-start",
                            width: "100%",
                            children: [
                                !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtonConnectWallet, {
                                    children: "Connect wallet"
                                }),
                                isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtonConnectWallet, {
                                    onClick: function() {
                                        return logout().then(function() {
                                            setSessionChainId(chainId);
                                        });
                                    },
                                    children: "Disconnect Wallet"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsLink, {
                                    href: "/swap",
                                    children: "TRADE NOW"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsRight, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/base_img/section3.png?version=1.1",
                        alt: ""
                    })
                })
            ]
        })
    });
};
var CsWrapperLink = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d71b8742-0"
})(Section3_templateObject());
var CsLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d71b8742-1"
})(Section3_templateObject1());
var CsRight = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d71b8742-2"
})(Section3_templateObject2());
var WrapperSection = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d71b8742-3"
})(Section3_templateObject3());
var Section3_CsContentLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d71b8742-4"
})(Section3_templateObject4(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disable;
});
/* harmony default export */ var components_Section3 = (Section3);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
;// CONCATENATED MODULE: ./src/views/HomeView/components/Section4.tsx

function Section4_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40%;\n  @media screen and (max-width: 760px){\n    width: 25%;\n  }\n  img{\n    width: 100%;\n    max-width: 718px;\n    max-height: 718px;\n  }\n"
    ]);
    Section4_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Section4_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  width: 60%;\n  @media screen and (max-width: 760px){\n    width: 75%;\n  }\n"
    ]);
    Section4_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Section4_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-around;\n  margin: 50px 0 100px;\n  padding: 0 20px;\n  position: relative;\n  right: 10px;\n  gap: 215px;\n  @media screen and (max-width: 768px){\n    margin: 60px 0;\n    padding: 0;\n    right: 0;\n    gap: 0;\n  }\n\n"
    ]);
    Section4_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Section4_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    align-items: left;\n    margin-bottom: 20px;\n    @media screen and (max-width: 768px){\n      margin-bottom: 10px;\n    }\n    ",
        "{\n      color: ",
        ";\n        &:first-child{\n          font-size: 48px;\n          font-weight: 900;\n          @media screen and (max-width: 768px){\n            font-size: 24px;\n          }\n        }\n        &:nth-child(2){\n          font-size: 18px;\n          letter-spacing: 0.05em;\n          color: ",
        ";\n          @media screen and (max-width: 768px){\n            font-size: 13px;\n          }\n        };\n    }\n"
    ]);
    Section4_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Section4_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  font-size: 14px;\n  height: 40px;\n  text-transform:uppercase;\n  @media screen and (max-width: 768px){\n        font-size: 10px;\n        height: 32px;\n    }\n"
    ]);
    Section4_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Section4 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section4_WrapperSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section4_CsLeft, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/base_img/section4.png?version=1.1",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section4_CsRight, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section4_CsContentLeft, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: "#62FFD9"
                                            },
                                            children: "Connect"
                                        }),
                                        " to the next ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " journey on BASE"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "1rem",
                                    children: "Exploit the values accross networks."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "flex-start",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                                    children: "launch app"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsLink, {
                                    href: "#",
                                    children: "Read the docs"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var Section4_CsLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a2dca47b-0"
})(Section4_templateObject());
var Section4_CsRight = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a2dca47b-1"
})(Section4_templateObject1());
var Section4_WrapperSection = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a2dca47b-2"
})(Section4_templateObject2());
var Section4_CsContentLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a2dca47b-3"
})(Section4_templateObject3(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disable;
});
var CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-a2dca47b-4"
})(Section4_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disable;
});
/* harmony default export */ var components_Section4 = (Section4);

;// CONCATENATED MODULE: ./src/views/HomeView/components/ItemSection6.tsx

function ItemSection6_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 400px;\n    height: 100%;\n    min-height: 380px;\n    border-radius: 10px;\n    margin-bottom: 5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: url(",
        ") center top / 100% 100% no-repeat;\n    padding: 3rem 2rem;\n    position: relative;\n    @media screen and (max-width: 1024px){\n      padding: 2rem 2rem;\n      margin-bottom: 2rem;\n      width: 100%;\n    }\n"
    ]);
    ItemSection6_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemSection6_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 28px;\n    margin-top: 80px;\n    line-height: 38px;\n    font-weight: 900;\n    letter-spacing: -0.02em;\n    color: ",
        ";\n    @media screen and (max-width: 1024px){\n        font-size: 20px;\n    }\n"
    ]);
    ItemSection6_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemSection6_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 14px;\n  margin-top: 16px;\n  @media screen and (max-width: 1024px){\n        font-size: 13px;\n    }\n"
    ]);
    ItemSection6_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemSection6_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 32px;\n    left: 32px;\n    width: 32px;\n    object-fit: contain;\n"
    ]);
    ItemSection6_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ItemSection6 = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSection6_WrapItem, {
        background: item === null || item === void 0 ? void 0 : item.img,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsImgLeft, {
                src: "/images/base_img/section6_2.png?version=1.3",
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSection6_CsTitle, {
                        children: [
                            " ",
                            item === null || item === void 0 ? void 0 : item.title,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSection6_CsSubTitle, {
                        children: [
                            " ",
                            item === null || item === void 0 ? void 0 : item.subTitle,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "fit-content",
                    backgroundColor: item === null || item === void 0 ? void 0 : item.background,
                    borderRadius: "50px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        letterSpacing: "1.5px",
                        padding: "10px",
                        fontSize: "14px",
                        color: item === null || item === void 0 ? void 0 : item.color,
                        fontWeight: "700",
                        children: "ONLINE"
                    })
                })
            })
        ]
    });
};
var ItemSection6_WrapItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-98e21560-0"
})(ItemSection6_templateObject(), function(param) {
    var background = param.background;
    return background;
});
var ItemSection6_CsTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-98e21560-1"
})(ItemSection6_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.title;
});
var ItemSection6_CsSubTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-98e21560-2"
})(ItemSection6_templateObject2());
var CsImgLeft = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-98e21560-3"
})(ItemSection6_templateObject3());
/* harmony default export */ var components_ItemSection6 = (ItemSection6);

;// CONCATENATED MODULE: ./src/views/HomeView/components/Section6.tsx

function Section6_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1320px;\n    padding: 0 20px;\n    margin: auto;\n    width: 100%;\n    border-radius: 16px;\n    background: #0081E2;\n    margin-bottom: 265px;\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    padding: 63px 0px 63px 130px;\n    position: relative;\n    .item-countdown{\n        display: flex;\n        align-items: center;\n        gap: 30px;\n        @media screen and (max-width: 1024px){\n            display: grid;\n            grid-template-columns: repeat(2, minmax(0, 1fr));\n            width: 100%;\n        }\n\n    }\n    @media screen and (max-width: 1024px){\n        padding: 22px 36px;\n        width: 100%;\n        margin-bottom: 52px;\n    }\n    img{\n        width: 150px;\n        height: 150px;\n        position: absolute;\n        top: 50%;\n        left: 30px;\n        @media screen and (max-width: 1024px){\n            display: none;\n        }\n    }\n    h1{\n        color: #FFF;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 900;\n        line-height: 38.4px;\n        letter-spacing: -0.64px;\n    }\n    p{\n        color: #62FFD9;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 27px;\n        letter-spacing: -0.36px;\n    }\n"
    ]);
    Section6_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Section6_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: -200px;\n    right: -300px;\n    width: 500px;\n    object-fit: contain;\n    z-index: 1;\n    @media screen and (max-width: 1024px){\n      right: -300px;\n      top: -200px;\n    }\n    @media screen and (max-width: 768px){\n      width: 300px;\n      right: -200px;\n      top: -100px;\n    }\n"
    ]);
    Section6_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var dataSection6 = [
    {
        id: 1,
        img: "/images/base_img/threeBig.png",
        title: "All Base Assets/DApp supported",
        subTitle: "And more to be added to the platform",
        link: "",
        color: "#89EB5B",
        background: "rgba(137, 235, 91, 0.05)"
    },
    {
        id: 2,
        img: "/images/base_img/oneBig.png",
        title: "$19.11M Liquidity",
        subTitle: "Used and trusted globally",
        link: "",
        color: "#6F5BEB",
        background: "rgba(111, 91, 235, 0.05)"
    },
    {
        id: 3,
        img: "/images/base_img/twoBig.png",
        title: "2M+ transactions",
        subTitle: "Secured by a permissionless system",
        link: "",
        color: "#FFC600",
        background: "rgba(255, 198, 0, 0.05)"
    }
];
var Section6 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsHeaderSection, {
                    children: "STATISTIC"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapListItem, {
                    children: dataSection6 === null || dataSection6 === void 0 ? void 0 : dataSection6.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSection6, {
                                item: item
                            })
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsImgRight, {
                    src: "/images/base_img/section6.png?version=1.2",
                    alt: ""
                })
            ]
        })
    });
};
var CsCountdownTransition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40c21c0d-0"
})(Section6_templateObject());
var CsImgRight = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-40c21c0d-1"
})(Section6_templateObject1());
/* harmony default export */ var components_Section6 = (Section6);

;// CONCATENATED MODULE: ./src/views/HomeView/components/Section7.tsx

function Section7_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1320px;\n    margin: auto;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 120px;\n    margin-top: 186px;\n    @media screen and (max-width: 1024px){\n        grid-template-columns: repeat(1, minmax(0, 1fr));\n        margin-top: 40px;\n        gap: 24px;\n    }\n    h4{\n        color: #FFF;\n        font-size: 60px;\n        font-style: normal;\n        font-weight: 900;\n        line-height: 88px;\n        @media screen and (max-width: 1024px){\n            font-size: 24px;\n            text-align: center;\n            line-height: normal;\n        }\n    }\n    p{\n        color: #ffff;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 400;\n        margin-top: 18px;\n        line-height: 36px;\n        @media screen and (max-width: 1024px){\n            font-size: 12px;\n            text-align: center;\n            line-height: normal;\n        }\n    }\n    img{\n        position: relative;\n        bottom: 135px;\n        @media screen and (max-width: 1024px){\n            bottom: 0;\n        }\n    }\n"
    ]);
    Section7_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Section7_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-bottom: 100px;\n    justify-content: center;\n    position: relative;\n    height: 100%;\n    z-index: 1;\n"
    ]);
    Section7_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Section7_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    z-index: 0;\n    margin-left: 70px;\n    @media screen and (max-width: 1024px){\n        width: 100%;\n        height: 100%;\n        max-width: 100%;\n        left: 0;\n        right: 0;\n        z-index: 0;\n        margin-left: 0;\n    }\n"
    ]);
    Section7_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Section7_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 100px;\n    padding-bottom: 160px;\n    left: 50%;\n    top: 50%;\n    right: 50%;\n    width: 550px;\n    height: 100px;\n    transform: translate(-50%, -50%);\n    margin: 0 auto;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    @media screen and (max-width: 768px){\n        padding-left: 0px;\n    }\n    ",
        "{\n        letter-spacing: -0.02em;\n        text-align: center;\n        color: ",
        ";\n        &:first-child{\n            font-size: 60px;\n            font-weight:700;\n            @media screen and (max-width: 768px){\n                font-size: 24px;\n            }\n        }\n        &:nth-child(2){\n            font-size: 24px;\n            @media screen and (max-width: 768px){\n                font-size: 12px;\n                margin-top: 12px;\n            }\n        }\n    }\n"
    ]);
    Section7_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Section7_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    &:hover{\n        text-decoration:none;\n    }\n"
    ]);
    Section7_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Section7_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    @media screen and (max-width: 768px){\n        font-size: 12px;\n    }\n"
    ]);
    Section7_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Section7_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: 290px;\n    position: relative;\n    height: 550px;\n    width: 100%;\n    @media screen and (max-width: 1024px){\n        bottom: 0;\n        height: 100%;\n        }\n    img{\n        height: 230%;\n        @media screen and (max-width: 1024px){\n            height: 100%;\n        }\n    }\n    ",
        "\n    {\n        top: 630px;\n        @media screen and (max-width: 1024px){\n            top: 50%;\n        }\n\n    }\n"
    ]);
    Section7_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var Section7 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsSupportChains, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Support Chains"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "images/base_img/group-chains.png",
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section7_Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsImgMain, {
                            src: "/images/base_img/section9.png?version=1.3",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "Join us now"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "Read our Whitepaper."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section7_CsLink, {
                                        href: "#",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section7_CsButton, {
                                            children: "JOIN THE COMMUNITY"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var CsSupportChains = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe9ffe-0"
})(Section7_templateObject());
var Section7_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cefe9ffe-1"
})(Section7_templateObject1());
var CsImgMain = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-cefe9ffe-2"
})(Section7_templateObject2());
var WrapContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cefe9ffe-3"
})(Section7_templateObject3(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var Section7_CsLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-cefe9ffe-4"
})(Section7_templateObject4());
var Section7_CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-cefe9ffe-5"
})(Section7_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disable;
});
var SectionContainer = (0,styled_components_browser_esm/* default */.ZP)(Container).withConfig({
    componentId: "sc-cefe9ffe-6"
})(Section7_templateObject6(), WrapContent);
/* harmony default export */ var components_Section7 = (Section7);

;// CONCATENATED MODULE: ./src/views/HomeView/Home.tsx









var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomPage, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section1, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section2, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section3, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section4, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section6, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section7, {})
        ]
    });
};
/* harmony default export */ var HomeView_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeView_Home, {});
};
IndexPage.chains = wagmi/* SUPPORT_CHAIN_CLOUDBASE */.Oj;
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [188,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);